import React, { createContext } from 'react';

export const NavContext = createContext('home');
export const LanguageContext = createContext('en');
export const TesContext = createContext('tes');

// export {
//     NavContext,
//     LanguageContext,
//     TesContext
// };